import React, { useCallback, useState } from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Section from 'ui/atoms/section';
import ProductsTable from 'apps/issuer/pages/products/products-table';
import useGoTo from 'hooks/use-go-to';
import { ISSUER_ROUTES } from 'apps/issuer/pages/routes.config';
import { useCurrentUserSelector } from 'src/core/auth/hooks';
import Button from 'src/ui/atoms/button';
import AddProduct from './add-product';
import { hasViewPermission } from '../../helpers/tokenPermissions';
import { hasDistributionViewDataPermission } from '../../helpers/distributionPlatformPermissions';
import PageWrapper from 'src/core/layout/content/page-wrapper';

const IssuerProductsPage = () => {
  const [isAddProductModalOpen, setAddProductModalOpen] = useState(false);
  const [forceDataLoad, setForceDataLoad] = useState(false);
  const [filterPopupHeight, setFilterPopupHeight] = useState(0);

  const { currentUser } = useCurrentUserSelector();

  const goToProductDetails = useGoTo(ISSUER_ROUTES.productDetails);

  const refreshTableData = useCallback(() => {
    setForceDataLoad(true);
  }, []);

  const hasPermission =
    hasDistributionViewDataPermission(currentUser?.associatedDistributionPlatforms || []) ||
    hasViewPermission(currentUser) ||
    !!currentUser?.canCreateProducts;

  return (
    <PageWrapper paddingBottom={filterPopupHeight}>
      <WideContent title={<Translate name="dashboard.issuerProducts" />} titleSpacing="larger">
        <Section spacing="small">
          <Translate name="issuerProducts.subtitle" />
        </Section>
        {currentUser?.canCreateProducts && (
          <Section>
            <Button
              variant="primary"
              icon="plus"
              size="small"
              iconSize="small"
              iconColor="inherit"
              onClick={() => setAddProductModalOpen(true)}
            >
              <Translate name="addProduct.add" />
            </Button>
          </Section>
        )}
        <Section>
          <ProductsTable
            defaultLimit={50}
            goToDetails={(productId: string) => goToProductDetails({ productId })}
            forceDataLoad={forceDataLoad}
            setForceDataLoad={setForceDataLoad}
            hasPermission={hasPermission}
            setFilterPopupHeight={setFilterPopupHeight}
          />
        </Section>
        {isAddProductModalOpen && (
          <AddProduct onClose={() => setAddProductModalOpen(false)} onAddNewProduct={refreshTableData} />
        )}
      </WideContent>
    </PageWrapper>
  );
};

export default WithAuthenticatedPage(IssuerProductsPage, AppType.ISSUER);
